<template>
  <div class="home-page">
    <div class="content-container">
      <!-- 数据统计卡片 -->
      <div class="data-cards">
        <div class="data-card" v-for="(c, i) in cards" :key="i">
          <div class="card-icon" :style="{ background: c.gradient }">
            <i :class="c.icon"></i>
          </div>
          <div class="card-info">
            <div class="card-label">{{ c.label }}</div>
            <div class="data-value">
              <span class="num" :style="{ color: c.color }">{{ c.value }}</span>
              <span class="unit">{{ c.unit }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 图表区 -->
      <div class="chart-section">
        <div class="chart-card">
          <div class="section-header">
            <h3><i class="el-icon-data-line sec-icon"></i>近 7 天告警趋势</h3>
            <span class="chart-legend">
              <span class="lg-dot" style="background:#F53F3F"></span>P0
              <span class="lg-dot" style="background:#FF7D00"></span>P1
              <span class="lg-dot" style="background:#165DFF"></span>P2
            </span>
          </div>
          <div ref="trendChart" class="chart-body"></div>
        </div>
        <div class="chart-card">
          <div class="section-header">
            <h3><i class="el-icon-pie-chart sec-icon"></i>设备状态分布</h3>
          </div>
          <div ref="distChart" class="chart-body"></div>
        </div>
      </div>

      <!-- 快捷入口 -->
      <div class="quick-section">
        <div
          v-for="q in quickLinks"
          :key="q.path"
          class="quick-item"
          @click="$router.push(q.path)"
        >
          <i :class="q.icon" :style="{ color: q.color, background: q.bg }"></i>
          <span>{{ q.name }}</span>
        </div>
      </div>

      <!-- 地图 + 告警 -->
      <div class="bottom-section">
        <div class="map-container">
          <div class="section-header">
            <h3><i class="el-icon-map-location sec-icon"></i>设备实时分布</h3>
            <span class="update-time"><i class="el-icon-video-play"></i> 实时监控</span>
          </div>
          <div class="map-wrapper">
            <TMapPicker mode="markers" :center="mapCenter" :markers="markers" :height="320" @marker-click="onMarker" />
          </div>
        </div>

        <div class="calendar-container">
          <div class="section-header">
            <h3><i class="el-icon-bell sec-icon"></i>最新告警</h3>
            <span class="more-link" @click="goAlert">查看全部 <i class="el-icon-arrow-right"></i></span>
          </div>
          <div class="events-wrapper">
            <div v-for="(a, i) in recentAlerts" :key="i" class="event-item">
              <span class="event-bar" :style="{ background: barColor(a.level) }"></span>
              <div class="event-body">
                <h6 class="event-title">
                  <el-tag :type="levelType(a.level)" size="mini">{{ levelText(a.level) }}</el-tag>
                  {{ a.title }}
                </h6>
                <p class="event-content">{{ a.detail }}</p>
              </div>
            </div>
            <div v-if="!recentAlerts.length" class="no-events">
              <i class="el-icon-circle-check"></i>
              <span>暂无告警，一切正常</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TMapPicker from '@/views/components/TMapPicker.vue'
import { getMonitor, getSecurity, getAlerts, getWorkOrders } from '@/api/sentinel'

export default {
  name: 'HomePage',
  components: { TMapPicker },
  data() {
    return {
      cards: [
        { label: '设备总数', value: 0, unit: '台', color: '#165dff', icon: 'el-icon-truck', gradient: 'linear-gradient(135deg, #4080FF, #165DFF)' },
        { label: '在线设备', value: 0, unit: '台', color: '#00b42a', icon: 'el-icon-video-play', gradient: 'linear-gradient(135deg, #35D97A, #00B42A)' },
        { label: '今日告警', value: 0, unit: '条', color: '#f53f3f', icon: 'el-icon-bell', gradient: 'linear-gradient(135deg, #FF7D7D, #F53F3F)' },
        { label: '限速区域', value: 0, unit: '个', color: '#ff7d00', icon: 'el-icon-warning-outline', gradient: 'linear-gradient(135deg, #FFA940, #FF7D00)' },
        { label: '待派工单', value: 0, unit: '单', color: '#722ED1', icon: 'el-icon-s-order', gradient: 'linear-gradient(135deg, #9254DE, #722ED1)' }
      ],
      quickLinks: [
        { name: '设备管理', path: '/device', icon: 'el-icon-truck', color: '#165DFF', bg: 'rgba(22,93,255,.1)' },
        { name: '告警中心', path: '/alert', icon: 'el-icon-bell', color: '#F53F3F', bg: 'rgba(245,63,63,.1)' },
        { name: '安全管理', path: '/security', icon: 'el-icon-warning-outline', color: '#FF7D00', bg: 'rgba(255,125,0,.1)' },
        { name: '轨迹回放', path: '/track', icon: 'el-icon-position', color: '#00B42A', bg: 'rgba(0,180,42,.1)' },
        { name: '运维工单', path: '/workorder', icon: 'el-icon-s-order', color: '#722ED1', bg: 'rgba(114,46,209,.1)' },
        { name: '报表中心', path: '/report', icon: 'el-icon-s-data', color: '#13C2C2', bg: 'rgba(19,194,194,.1)' }
      ],
      markers: [],
      mapCenter: { lat: 30.2741, lng: 120.1551 },
      recentAlerts: [],
      trendChart: null,
      distChart: null
    }
  },
  mounted() {
    this.loadMonitor()
    this.loadSecurity()
    this.loadAlerts()
    this.loadWorkOrders()
    this.initCharts()
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
    if (this.trendChart) this.trendChart.dispose()
    if (this.distChart) this.distChart.dispose()
  },
  methods: {
    loadMonitor() {
      getMonitor().then(res => {
        if (res.code === 200) {
          const d = res.data || {}
          const list = d.markers || d.devices || []
          this.markers = list.map(m => ({
            id: m.id,
            lat: +m.lat,
            lng: +m.lng,
            title: m.title || m.name || m.sn,
            status: m.status
          }))
          if (this.markers.length) this.mapCenter = { lat: this.markers[0].lat, lng: this.markers[0].lng }
          if (typeof d.total !== 'undefined') this.cards[0].value = d.total
          if (typeof d.online !== 'undefined') this.cards[1].value = d.online
        }
      }).catch(() => {})
    },
    loadSecurity() {
      getSecurity().then(res => {
        if (res.code === 200) {
          const z = (res.data && res.data.zstats) || {}
          this.cards[3].value = z.zoneCount || 0
        }
      }).catch(() => {})
    },
    loadAlerts() {
      getAlerts().then(res => {
        if (res.code === 200) {
          const d = res.data || {}
          const stats = d.stats || []
          this.cards[2].value = stats.reduce((s, x) => s + (x.value || 0), 0)
          this.recentAlerts = (d.alerts || []).slice(0, 6)
          this.renderDistChart()
        }
      }).catch(() => {})
    },
    loadWorkOrders() {
      getWorkOrders().then(res => {
        if (res.code === 200) {
          const stat = (res.data && res.data.stat) || {}
          this.cards[4].value = stat.pending || 0
        }
      }).catch(() => {})
    },
    /* ---------- ECharts ---------- */
    initCharts() {
      // 告警趋势（近 7 天，P0/P1/P2 三条线）
      this.trendChart = this.$echarts.init(this.$refs.trendChart)
      this.trendChart.setOption({
        tooltip: { trigger: 'axis' },
        legend: { show: false },
        grid: { left: 36, right: 16, top: 40, bottom: 28 },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: ['08-19', '08-20', '08-21', '08-22', '08-23', '08-24', '08-25'],
          axisLine: { lineStyle: { color: '#E5E6EB' } },
          axisLabel: { color: '#86909C' }
        },
        yAxis: {
          type: 'value',
          minInterval: 1,
          splitLine: { lineStyle: { color: '#F2F3F5' } },
          axisLabel: { color: '#86909C' }
        },
        series: [
          { name: 'P0', type: 'line', smooth: true, symbolSize: 5, data: [1, 2, 0, 3, 1, 2, 1], itemStyle: { color: '#F53F3F' }, areaStyle: { opacity: 0.06 } },
          { name: 'P1', type: 'line', smooth: true, symbolSize: 5, data: [5, 6, 4, 8, 7, 5, 6], itemStyle: { color: '#FF7D00' }, areaStyle: { opacity: 0.06 } },
          { name: 'P2', type: 'line', smooth: true, symbolSize: 5, data: [12, 14, 11, 19, 17, 12, 17], itemStyle: { color: '#165DFF' }, areaStyle: { opacity: 0.08 } }
        ]
      })

      // 设备状态分布（环形图）
      this.distChart = this.$echarts.init(this.$refs.distChart)
      this.renderDistChart()
    },
    renderDistChart() {
      if (!this.distChart) return
      const data = [
        { name: '在线', value: this.cards[1].value || 26 },
        { name: '离线', value: 4 },
        { name: '故障', value: 2 },
        { name: '未激活', value: 1 }
      ]
      this.distChart.setOption({
        tooltip: { trigger: 'item', formatter: '{b}: {c} 台 ({d}%)' },
        legend: { bottom: 0, icon: 'circle', itemWidth: 8, itemHeight: 8, textStyle: { color: '#4E5969', fontSize: 12 } },
        color: ['#00B42A', '#86909C', '#F53F3F', '#FF7D00'],
        series: [{
          type: 'pie',
          radius: ['52%', '72%'],
          center: ['50%', '44%'],
          avoidLabelOverlap: false,
          label: { show: false },
          emphasis: { label: { show: true, fontSize: 14, fontWeight: 600 } },
          labelLine: { show: false },
          data
        }]
      })
    },
    handleResize() {
      if (this.trendChart) this.trendChart.resize()
      if (this.distChart) this.distChart.resize()
    },
    levelText(l) { return l === 0 ? 'P0' : l === 1 ? 'P1' : 'P2' },
    levelType(l) { return l === 0 ? 'danger' : l === 1 ? 'warning' : 'primary' },
    barColor(l) { return l === 0 ? '#F53F3F' : l === 1 ? '#FF7D00' : '#165DFF' },
    onMarker(item) {
      this.$message.info((item.title || '设备') + (item.status ? ' · ' + item.status : ''))
    },
    goAlert() {
      this.$router.push('/alert')
    }
  }
}
</script>

<style scoped lang="css">
.home-page { width: 100%; display: flex; flex-direction: column; height: 100%; min-height: 0; }
.content-container { flex: 1; overflow-y: auto; padding: 10px 0; min-height: 0; }

/* ============ 数据卡片 ============ */
.data-cards { display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 14px; margin-bottom: 16px; }
.data-card {
  background-color: #fff;
  border-radius: 12px;
  border: 1px solid #E5E6EB;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04), 0 4px 12px rgba(16, 24, 40, 0.05);
  padding: 18px;
  display: flex;
  align-items: center;
  gap: 14px;
  transition: all .3s ease;
  position: relative;
  overflow: hidden;
}
.data-card::after {
  content: '';
  position: absolute;
  right: -30px;
  top: -30px;
  width: 90px;
  height: 90px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(22, 93, 255, 0.06) 0%, transparent 70%);
}
.data-card:hover {
  box-shadow: 0 8px 24px rgba(16, 24, 40, 0.10);
  transform: translateY(-2px);
}
.card-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 12px;
  color: #fff;
  font-size: 21px;
  flex-shrink: 0;
  box-shadow: 0 4px 10px rgba(16, 24, 40, 0.12);
}
.card-info { flex: 1; }
.card-label { font-size: 13px; color: #86909C; margin-bottom: 5px; }
.data-value { display: flex; align-items: baseline; gap: 5px; }
.data-value .num { font-size: 25px; font-weight: 700; line-height: 1; }
.data-value .unit { font-size: 13px; color: #86909C; }

/* ============ 图表区 ============ */
.chart-section { display: grid; grid-template-columns: 2fr 1fr; gap: 16px; margin-bottom: 16px; }
.chart-card {
  background-color: #fff;
  border-radius: 12px;
  border: 1px solid #E5E6EB;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04), 0 4px 12px rgba(16, 24, 40, 0.05);
  padding: 18px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.chart-card .section-header { flex-shrink: 0; margin-bottom: 8px; }
.chart-body { height: 200px; min-height: 0; overflow: hidden; }
.chart-legend { display: flex; align-items: center; gap: 6px; font-size: 12px; color: #86909C; }
.chart-legend .lg-dot { width: 8px; height: 8px; border-radius: 50%; display: inline-block; margin-left: 8px; }
.chart-legend .lg-dot:first-child { margin-left: 0; }

/* ============ 快捷入口 ============ */
.quick-section {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 14px;
  margin-bottom: 16px;
}
.quick-item {
  background-color: #fff;
  border-radius: 12px;
  border: 1px solid #E5E6EB;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04), 0 4px 12px rgba(16, 24, 40, 0.05);
  padding: 16px 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  transition: all .25s ease;
}
.quick-item:hover {
  box-shadow: 0 8px 24px rgba(16, 24, 40, 0.10);
  transform: translateY(-3px);
  border-color: rgba(22, 93, 255, 0.3);
}
.quick-item i {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 21px;
}
.quick-item span { font-size: 13px; color: #4E5969; font-weight: 500; }

/* ============ 底部双栏 ============ */
.bottom-section { display: grid; grid-template-columns: 1fr 330px; gap: 16px; }
.map-container {
  background-color: #fff;
  border-radius: 12px;
  border: 1px solid #E5E6EB;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04), 0 4px 12px rgba(16, 24, 40, 0.05);
  padding: 18px;
  height: 360px;
  display: flex;
  flex-direction: column;
}
.section-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 14px; }
.section-header h3 { margin: 0; font-size: 15px; font-weight: 600; color: #1D2129; display: flex; align-items: center; gap: 8px; }
.sec-icon { color: #165DFF; font-size: 16px; }
.update-time { font-size: 12px; color: #00B42A; background: rgba(0, 180, 42, 0.08); padding: 3px 10px; border-radius: 12px; }
.more-link { font-size: 12px; color: #165dff; cursor: pointer; display: flex; align-items: center; gap: 2px; transition: all .2s ease; }
.more-link:hover { color: #4080FF; }
.map-wrapper { flex: 1; position: relative; background-color: #EEF1F6; border-radius: 10px; overflow: hidden; }
.calendar-container {
  background-color: #fff;
  border-radius: 12px;
  border: 1px solid #E5E6EB;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04), 0 4px 12px rgba(16, 24, 40, 0.05);
  padding: 18px;
  height: 360px;
  display: flex;
  flex-direction: column;
}
.events-wrapper { flex: 1; display: flex; flex-direction: column; gap: 10px; overflow-y: auto; }
.event-item {
  display: flex;
  gap: 10px;
  padding: 11px 12px;
  background-color: #F7F8FA;
  border-radius: 10px;
  transition: all .2s ease;
}
.event-item:hover { background-color: #F0F3F8; }
.event-bar { width: 3px; border-radius: 2px; flex-shrink: 0; }
.event-body { flex: 1; min-width: 0; }
.event-title { margin: 0 0 5px 0; font-size: 13px; font-weight: 600; color: #1D2129; display: flex; align-items: center; gap: 6px; }
.event-title .el-tag { margin-right: 2px; }
.event-content { margin: 0; font-size: 12px; color: #4E5969; line-height: 1.5; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.no-events { text-align: center; color: #86909C; font-size: 13px; padding: 40px 0; display: flex; flex-direction: column; align-items: center; gap: 8px; }
.no-events i { font-size: 36px; color: #00B42A; }

@media (max-width: 1200px) {
  .quick-section { grid-template-columns: repeat(3, 1fr); }
}
@media (max-width: 768px) {
  .chart-section { grid-template-columns: 1fr; }
  .bottom-section { grid-template-columns: 1fr; }
  .map-container, .calendar-container { height: auto; min-height: 320px; }
  .quick-section { grid-template-columns: repeat(2, 1fr); }
}
</style>
